import { render, staticRenderFns } from "./VolumeTransactionBySimType.vue?vue&type=template&id=39a15cc0&"
import script from "./VolumeTransactionBySimType.vue?vue&type=script&lang=js&"
export * from "./VolumeTransactionBySimType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports